import React, { Component, useState, createRef } from "react";
import "../styles/results.scss";
import HandphoneIcon from "../icons/handphone.svg";
import CalenderIcon from "../icons/calender.svg";
import BquizResultIcon from "../icons/bquizResult.svg";
import CorrectIcon from "../icons/correct.svg";
import FalseIcon from "../icons/false.svg";
import Sticker from "./sticker";

export default class Results extends Component {
  render() {
    const { data } = this.props;
    const isZeroIncentive =
      data.earned_incentive === "" ||
      data.earned_incentive.toString() === "0" ||
      data.earned_incentive === "0";
    return (
      <div className="quiz-result-container">
        <img src={HandphoneIcon} className="phone-icon" />
        {data.participated === true && (
          <p className="result-error">{data.message}</p>
        )}
        {isZeroIncentive ? (
          <h2>শুভেচ্ছা!</h2>
        ) : (
          <h2>শুভেচ্ছা! আপনি বোনাস পেয়েছেন</h2>
        )}

        <div className="quiz-result-content">
          <img src={BquizResultIcon} />
          <div className="quiz-result-content-inner">
            <div className="correct">
              <img src={CorrectIcon} />
              <p>{data.correct_answer}</p>টি সঠিক
            </div>
            <div className="false">
              <img src={FalseIcon} />
              <p>{data.incorrect_answer}</p>টি ভুল
            </div>
          </div>
        </div>

        {!isZeroIncentive && (
          <Sticker title={data.earned_incentive} subTitle="টাকা" />
        )}

        <img src={CalenderIcon} />
        {!isZeroIncentive && (
          <p className="result-footer">{data.payout_text}</p>
        )}
      </div>
    );
  }
}
